import { ChangeDetectorRef, Component, Input, inject } from "@angular/core";
import { TaskDetailDto, TasksClientProvider, TaskContactDto, TaskContactCreateCommand, TaskContactDeleteCommand, } from "src/app/web-api/web-api";
import { UserService } from "src/app/services/user.service";
import { CstDialogsService } from "src/app/common-components/dialogs/cst-dialogs.service";
import { CstDialogResult } from "src/app/common-components/dialogs/cst-dialog-enums";
import { PlanungApiTaskContactCreateComponent } from "../../task-contact/create/create.component";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";

@Component({
    selector: "app-planung-task-detail-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    standalone: false
})
export class PlanungApiTaskDetailSidebarComponent {
    private _userService = inject(UserService);
    private _client = inject(TasksClientProvider);
    private _msg = inject(CstDialogsService);
    private _popupService = inject(CstResponsivePopupService);
    private _changeDetectorRef = inject(ChangeDetectorRef);

    @Input() task: TaskDetailDto = null;

    public ShouldDisplayContactsAddSelf() {
        if (!this.task) {
            return false;
        }
        const usr = this._userService.CurrentUser;
        if (!usr || !usr.email) {
            return false;
        }
        return this.task.contacts.findIndex((x) => x.email === usr.email) < 0;
    }
    public OnContactAddSelf() {
        const usr = this._userService.CurrentUser;
        if (!usr || !usr.email) {
            return false;
        }
        const command = new TaskContactCreateCommand();
        command.init({
            taskID: this.task.id,
            label: `${usr.firstName} ${usr.lastName}`,
            email: usr.email,
        });
        const newContact = new TaskContactDto();
        newContact.init(command);
        this.task.contacts = [...this.task.contacts, newContact];
        this._changeDetectorRef.detectChanges();
        this._client.contactCreate(command).subscribe(
            (result) => {
                newContact.id = result.id;
            },
            (error) => {
                console.log(error);
                this.task.contacts = this.task.contacts.filter(c => c !== newContact);
                this._changeDetectorRef.detectChanges();
            }
        );
    }
    public OnContactAddNew() {
        this._popupService.open<PlanungApiTaskContactCreateComponent, string, TaskContactDto>(PlanungApiTaskContactCreateComponent, { data: this.task.id })
            .afterClosed()
            .subscribe((result) => {
                if (!(result instanceof TaskContactDto)) {
                    return;
                }
                this.task.contacts = [...this.task.contacts, result];
                this._changeDetectorRef.detectChanges();
            })
    }
    public OnContactDelete(id: string) {
        if (!id) {
            return;
        }
        this._msg
            .AskYesNo(
                $localize`:@@Planung_TaskDetail_Sidebar_ContactDelete_Confirm:Do you really want to remove this contact from the list?`
            )
            .subscribe((result) => {
                if (result !== CstDialogResult.Yes) {
                    return;
                }
                const command = new TaskContactDeleteCommand();
                command.init({ id });
                this._client.contactDelete(command).subscribe(() => {
                    this.task.contacts = this.task.contacts.filter((x) => x.id !== id);
                    this._changeDetectorRef.detectChanges();
                });
            });
    }
}
